export const accounting = {
  menuLabel: 'Accounting',
};
